import { render, staticRenderFns } from "./VideoForm.vue?vue&type=template&id=2bc0b92e&scoped=true&"
import script from "./VideoForm.vue?vue&type=script&lang=ts&"
export * from "./VideoForm.vue?vue&type=script&lang=ts&"
import style0 from "./VideoForm.vue?vue&type=style&index=0&id=2bc0b92e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc0b92e",
  null
  
)

export default component.exports